import InputAnimatedPlaceholder from '@trustoo/components/input/InputAnimatedPlaceholder'
import InputErrorMessage from '@trustoo/components/input/InputErrorMessage'
import InputLegend from '@trustoo/components/input/InputLegend'
import clsx from 'clsx'
import { CSSProperties, ReactNode } from 'react'

interface FieldWrapperProps {
    children: ReactNode
    id?: string
    hasValue?: boolean
    error?: string | boolean
    isFocused: boolean
    isDisabled?: boolean
    legend?: string
    animatedPlaceholder?: ReactNode
    className?: string
    labelClassName?: string
    labelStyle?: CSSProperties
    errorClassName?: string
    defaultErrorMsg?: string
    withErrorIcon?: boolean
}

export const InputWrapper = ({
    children,
    id,
    hasValue,
    error,
    isFocused,
    isDisabled,
    legend,
    animatedPlaceholder,
    className,
    labelClassName,
    labelStyle,
    errorClassName,
    defaultErrorMsg,
    withErrorIcon,
}: FieldWrapperProps) => {
    return (
        <div className={className} data-field-has-error={error ? true : undefined}>
            {legend && <InputLegend legend={legend} />}
            <label
                htmlFor={id}
                className={clsx(
                    'relative flex items-center',
                    isDisabled ? 'bg-grey-100' : 'bg-white',
                    'rounded border border-solid text-typography-text-lg',
                    'transition-[border-color] duration-[140ms] ease-in-out',
                    error ? 'border-[red]' : 'border-[#b6b9cd]',
                    labelClassName,
                )}
                style={labelStyle}>
                {children}
                {animatedPlaceholder && (
                    <InputAnimatedPlaceholder
                        placeholder={animatedPlaceholder}
                        isFocused={isFocused}
                        hasValue={hasValue}
                        hasError={!!error}
                    />
                )}
            </label>
            {error && (
                <InputErrorMessage
                    error={error}
                    defaultErrorMsg={defaultErrorMsg}
                    className={errorClassName}
                    withIcon={withErrorIcon}
                />
            )}
        </div>
    )
}

export default InputWrapper
